export default __webpack_public_path__ + "static/media/carousel2.8017868f.jpg";